import React from 'react';
import { SvgIcon } from './typings';
/* eslint-disable max-len */
export const ChevronDownIcon: React.FC<SvgIcon> = (props) => (
  <svg {...props} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g opacity="0.6">
      <path d="M6 9L12 15L18 9" stroke="#6B798F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </g>
  </svg>
);
